import { render, staticRenderFns } from "./ClubModal.vue?vue&type=template&id=50d23b2f&"
import script from "./ClubModal.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ClubModal.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50d23b2f')) {
      api.createRecord('50d23b2f', component.options)
    } else {
      api.reload('50d23b2f', component.options)
    }
    module.hot.accept("./ClubModal.vue?vue&type=template&id=50d23b2f&", function () {
      api.rerender('50d23b2f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/TheFilters/common/components/ClubModal/ClubModal.vue"
export default component.exports